import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';
import type {
  SaleTradingPhotoCardType,
  MatchedTradingPhotoCardType
} from '../types/MarketCardType';

export const getPhotoCardMarketData = async (tabType: string) => {
  try {
    const response = await fetch(`${baseUrl()}${getApiEndpoint(tabType)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`
      }
    });

    if (!response.ok) {
      throw new Error(`API Request Failed: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    if (tabType === 'purchase' || tabType === 'sale') {
      return data.tradingPhotoCards?.filter(
        (photoCard: SaleTradingPhotoCardType) => photoCard.chatRooms?.length > 0
      );
    }

    return data.matchedTradingPhotoCards?.filter(
      (photoCard: MatchedTradingPhotoCardType) => photoCard.chatRooms.length > 0
    );
  } catch (error) {
    console.error('Photo Card Market Data Fetch Failed:', error);
    return [];
  }
};

const getApiEndpoint = (tabType: string) => {
  switch (tabType) {
    case 'purchase':
      return '/api/v2/trading_photo_cards/purchasing?per_page=10000';
    case 'sale':
      return '/api/v2/trading_photo_cards/selling?per_page=10000';
    case 'exchange_initiated':
      return '/api/v2/trading_photo_cards/exchanging?initiator=me&per_page=10000';
    case 'exchange_received':
      return '/api/v2/trading_photo_cards/exchanging?initiator=other&per_page=10000';
  }
};
